import React from 'react';
import ActivityChart from './ActivityChart';
import './ActivityChartCard.css'; // <-- Asegúrate de que esta línea esté presente

function ActivityChartCard({ activityData, customAccentColor, customTextColor, customGridColor }) {
    return (
        <div className="dp-activity-card dp-neumorphic dp-activity-card-landscape" style={{ gridColumn: '1 / -1' }}>
            <h2 className="dp-section-title">Actividad Mensual</h2>
            {/* Quitamos el 'style' y usamos la clase */}
            <div className="chart-container"> 
                {activityData && activityData.length > 0 ? (
                    <ActivityChart 
                        activityData={activityData} 
                        customAccentColor={customAccentColor} 
                        customTextColor={customTextColor} 
                        customGridColor={customGridColor} 
                    />
                ) : (
                    <p>No hay datos de actividad para mostrar.</p>
                )}
            </div>
        </div>
    );
}

export default ActivityChartCard;